module.exports = __webpack_public_path__ + "static/layers-ad4651bec208f43b8d7041a966bd8918.gif";